class Brand {
  constructor(params) {
    this.id = params.id;
    this.name = params.name;
    this.colorPrimary = params.colorPrimary;
    this.colorSecondary = params.colorSecondary;
    this.colorAlternate = params.colorAlternate;
    this.dealerMarkerActive = params.dealerMarkerActive;
    this.dealerMarkerActiveFeatured = params.dealerMarkerActiveFeatured;
    this.customMarkerColors = params.customMarkerColors;
    this.markerColors = this.getMarkerColors(params);
  }

  getMarkerColors(params) {
    const {colorPrimary, colorSecondary, customMarkerColors: custom} = params;
    const defaultColors = {inner: colorPrimary, outer: colorSecondary};

    return {
      active: (custom && custom.active) || defaultColors,
      hover: (custom && custom.hover) || defaultColors,
      default: (custom && custom.default) || defaultColors,
      location: (custom && custom.location) || defaultColors
    };
  }
}

export default Brand;
